import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { JsonViewer } from "./JsonViewer";
import { ViewJsonDialog } from "./ViewJsonDialog";

interface ViewJsonInPageProps {
	//string to be used at the top of the fullscreen dialog
	title: string;
	//Json to be used in the reactjson element in this dialog and in the fullscreen popup.
	json: object;
}

const useStyles = makeStyles((theme) => ({
	view: {
		backgroundColor: theme.palette.grey[100],
		maxHeight: 250,
		overflow: "auto",
		padding: theme.spacing(1),
	},
	expandButton: {
		textAlign: "right",
	},
}));

/**
 * Accepts a title string, a JSON object to be displayed and a nullable font size.
 * If the font is not provided then the json is displayed at 12 pt font.
 * The class should display an inpage Json Dialog as well as contains a button
 * allowing the json to be viewed in full screen.
 * @param props
 */
export const ViewJsonInPage = (props: ViewJsonInPageProps) => {
	const classes = useStyles();

	return (
		<div className={classes.view} data-testid={"view-json-in-page"}>
			<div className={classes.expandButton} data-testid={"view-json-fullscreen-button"}>
				<ViewJsonDialog label="Full Screen" title={props.title} json={props.json} />
			</div>
			{<JsonViewer json={props.json} />}
		</div>
	);
};
